import React from 'react';
import { Layout } from '../components/layout/Layout';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function CancellationPolicyPage() {
  return <Layout data-id="element-301">
      <div className="bg-gradient-to-br from-slate-50 to-teal-50 py-16" data-id="element-302">
        <div className="container mx-auto px-4 text-center" data-id="element-303">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-304">
            <h1 className="text-4xl font-bold text-slate-900 mb-4" data-id="element-305">
              Cancellation Policy
            </h1>
            <p className="text-slate-600 max-w-2xl mx-auto" data-id="element-306">
              Last updated:{' '}
              {new Date().toLocaleDateString('en-GB', {
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            })}
            </p>
          </motion.div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16" data-id="element-307">
        <div className="max-w-3xl mx-auto" data-id="element-308">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-teal-50 border border-teal-200 rounded-xl p-6 mb-8 flex items-start gap-4" data-id="element-309">
            <AlertCircle className="w-6 h-6 text-teal-600 flex-shrink-0 mt-0.5" data-id="element-310" />
            <div data-id="element-311">
              <h3 className="font-semibold text-teal-900 mb-2" data-id="element-312">
                Important Information
              </h3>
              <p className="text-teal-800 text-sm leading-relaxed" data-id="element-313">
                Please read this cancellation policy carefully before
                subscribing to HomeLinkPro. This policy explains your rights to
                cancel your subscription and the conditions that apply.
              </p>
            </div>
          </motion.div>

          <div className="prose prose-slate max-w-none" data-id="element-314">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-315">
              Your Right to Cancel
            </h2>

            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-316">
              At HomeLinkPro, we want you to be completely satisfied with our
              service. You have the right to cancel your subscription at any
              time, subject to the terms outlined below.
            </p>

            <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-317">
              Cancellation Within 14 Days
            </h3>
            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-318">
              If you cancel your subscription within 14 days of your initial
              purchase and have not used the platform, you are entitled to a
              full refund. "Not used" means you have not logged in, created any
              data, or accessed any features of the service.
            </p>

            <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-319">
              Cancellation After 14 Days
            </h3>
            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-320">
              After the initial 14-day period, cancellations may not qualify for
              a refund depending on your usage of the platform. If you have
              actively used the service (logged in, created data, or accessed
              features), you will retain access until the end of your current
              billing period, but no refund will be issued.
            </p>

            <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-321">
              How to Cancel
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-322">
              To cancel your subscription, you can:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6" data-id="element-323">
              <li data-id="element-324">
                Log in to your account and navigate to the subscription settings
              </li>
              <li data-id="element-325">
                Contact our support team at{' '}
                <a href="mailto:lbhuwan151@gmail.com" className="text-teal-600 hover:text-teal-700" data-id="element-326">
                  lbhuwan151@gmail.com
                </a>
              </li>
            </ul>

            <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-327">
              What Happens After Cancellation
            </h3>
            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-328">
              Once you cancel your subscription:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6" data-id="element-329">
              <li data-id="element-330">
                Your access will continue until the end of your current billing
                period
              </li>
              <li data-id="element-331">You will not be charged for the next billing cycle</li>
              <li data-id="element-332">
                Your data will be retained for 30 days after cancellation,
                allowing you to reactivate if you change your mind
              </li>
              <li data-id="element-333">
                After 30 days, your data will be permanently deleted in
                accordance with our Privacy & Cookie Policy
              </li>
            </ul>

            <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-334">
              Refund Processing
            </h3>
            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-335">
              If you are eligible for a refund under this cancellation policy,
              please refer to our
              <a href="/refund-policy" className="text-teal-600 hover:text-teal-700 ml-1" data-id="element-336">
                Refund Policy
              </a>{' '}
              for details on processing times and methods.
            </p>

            <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-337">
              Questions?
            </h3>
            <p className="text-slate-600 leading-relaxed" data-id="element-338">
              If you have any questions about this cancellation policy, please
              contact us at{' '}
              <a href="mailto:lbhuwan151@gmail.com" className="text-teal-600 hover:text-teal-700" data-id="element-339">
                lbhuwan151@gmail.com
              </a>{' '}
              or visit our{' '}
              <a href="/contact" className="text-teal-600 hover:text-teal-700" data-id="element-340">
                Contact Us
              </a>{' '}
              page.
            </p>
          </div>
        </div>
      </div>
    </Layout>;
}